import adminCoursesApprovalTemplate from './approval/template.html';
import AdminCoursesApprovalCtrl from './approval';
import adminCourseActivationTemplate from './get/template.html';
import AdminCourseActivationCtrl from './get';
import AdminCoursesNavCtrl from './nav';
import adminCoursesNavTemplate from './nav/template.html';

const adminCoursesState = {
  url: '/courses',
  abstract: true,
  resolve: {
    ResolveClass: 'ResolveClass',
    authenticateCompany: /* @ngInject */ ResolveClass => ResolveClass.authenticateCompany('/admin/courses')
  },
  views: {
    'a@app': {
      template: adminCoursesNavTemplate,
      controller: AdminCoursesNavCtrl,
      controllerAs: 'adminCoursesTabsCtrl'
    }
  }
};

const adminCoursesApprovalState = {
  url: '/review',
  stateName: 'Course Review',
  data: {
    specialClass: 'fixed-sidebar'
  },
  resolve: {
    ResolveClass: 'ResolveClass',
    authenticateCompany: /* @ngInject */ ResolveClass => ResolveClass.authenticateCompany('/admin/courses/review')
  },
  views: {
    a: {
      template: adminCoursesApprovalTemplate,
      controller: AdminCoursesApprovalCtrl
    }
  }
};

const adminCoursesActivationState = {
  url: '/activation',
  stateName: 'Course Activation',
  data: {
    specialClass: 'fixed-sidebar'
  },
  resolve: {
    ResolveClass: 'ResolveClass',
    authenticateCompany: /* @ngInject */ ResolveClass => ResolveClass.authenticateCompany('/admin/courses/activation')
  },
  views: {
    a: {
      template: adminCourseActivationTemplate,
      controller: AdminCourseActivationCtrl,
      controllerAs: 'AdminCourseActivationCtrl'
    }
  }
};

export { adminCoursesState, adminCoursesApprovalState, adminCoursesActivationState };



// WEBPACK FOOTER //
// ./src/app/controllers/admin/courses/index.js